import styles from './styles.module.scss';
import { PropTypes } from 'prop-types';
import { forwardRef } from 'react';

const CheckboxRow = forwardRef((props, ref) => {
  const { children, error, htmlFor, ...other } = props;
  return (
    <label
      className={`${styles.label} ${error ? styles.error : ''}`}
      htmlFor={htmlFor}
    >
      <span className={styles.text}>{children}</span>
      <input type="checkbox" className={styles.checkbox} {...other} ref={ref} />
    </label>
  );
});

CheckboxRow.displayName = 'CheckboxRow';

CheckboxRow.propTypes = {
  htmlFor: PropTypes.string,
  children: PropTypes.node,
  error: PropTypes.any,
};

export default CheckboxRow;
